import * as React from 'react';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CommentIcon from '@mui/icons-material/Comment';
import IconButton from '@mui/material/IconButton';

export default function BoardListItem(props) {
  const { subject, children } = props;
  return (
    <ListItem
      disableGutters
      secondaryAction={
        <IconButton aria-label="comment">
          <CommentIcon />
        </IconButton>
      }
      sx={{ m: 0, p: 0 }}
      divider
    >
      {/* <ListItemText primary={`Line item ${value}`} /> */}
      <ListItemText primary={subject} secondary={children} sx={{ m: 0, p: 0 }} />
    </ListItem>
  );
}
